<!--
/**
 * @copyright   OnlyOneProd © 2025
 * @authors     Jonathan COULLET <contact@onlyoneprod.com>
 * @link        https://onlyoneprod.com
 * @notice      All information contained herein is,
 *              and remains the property of OnlyOneProd and its suppliers,
 *              Any dissemination of this information or reproduction
 *              of this material is strictly forbidden unless prior
 *              written permission is obtained from OnlyOneProd.
 */
-->

<template>
    <svg width="48" height="48" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
        <g>
            <path
                d="M24 38.5C23.2667 38.5 22.6667 38.275 22.2 37.825C21.7333 37.375 21.5333 36.8167 21.6 36.15H19.9C19.641 36.15 19.3928 36.0315 19.1555 35.7945C18.9185 35.5572 18.8 35.309 18.8 35.05V29.35C16.6 28.1833 14.9333 26.625 13.8 24.675C12.6667 22.725 12.1 20.6667 12.1 18.5C12.1 15.1667 13.25 12.35 15.55 10.05C17.85 7.75 20.6667 6.6 24 6.6C27.3333 6.6 30.15 7.75 32.45 10.05C34.75 12.35 35.9 15.1667 35.9 18.5C35.9 20.6667 35.3363 22.726 34.209 24.678C33.082 26.6303 31.4123 28.1877 29.2 29.35V35.05C29.2 35.309 29.0815 35.5572 28.8445 35.7945C28.6075 36.0315 28.3593 36.15 28.1 36.15H26.4C26.4667 36.8167 26.2667 37.375 25.8 37.825C25.3333 38.275 24.7333 38.5 24 38.5ZM19.9 35.05H28.1V32.95H19.9V35.05ZM19.9 31.55H28.1V29.5H19.9V31.55ZM19.45 28.4H23.4V21.45L19.25 17.3L20.1 16.45L24 20.4L27.9 16.45L28.75 17.3L24.6 21.45V28.4H28.55C30.4167 27.5333 31.925 26.2167 33.075 24.45C34.225 22.6833 34.8 20.7002 34.8 18.5005C34.8 15.5002 33.75 12.95 31.65 10.85C29.55 8.75 27 7.7 24 7.7C21 7.7 18.45 8.75 16.35 10.85C14.25 12.95 13.2 15.5002 13.2 18.5005C13.2 20.7002 13.775 22.6833 14.925 24.45C16.075 26.2167 17.5833 27.5333 19.45 28.4Z"
                fill="currentColor" />
        </g>
    </svg>
</template>

<style lang="sass">
</style>